module.exports = __webpack_public_path__ + "static/media/instagram-alt.362004d7.png";